// extracted by mini-css-extract-plugin
module.exports = {"wrContacts":"WrContacts_wrContacts__-pTK-","particles":"WrContacts_particles__1graS","container":"WrContacts_container__2Ruek","submit":"WrContacts_submit__3lWzN"};